<template>
  <div>
    <appbar></appbar>
   
   <!-- this is to show the demo of the new design -->
   <div v-if="this.$route.fullPath.includes('newdesigntest')" style="display: flex;">

      <jbsSideTabs>

          <jbsTab icon="fas fa-columns"> Dashboard  </jbsTab>
          <jbsTab icon="fas fa-columns">  dd </jbsTab>
          <jbsTab icon="fas fa-columns"> ss  </jbsTab>
          <jbsTab icon="fas fa-columns"> dd  </jbsTab>
          <jbsTab icon="fas fa-columns"> aa  </jbsTab>
          <jbsTab icon="fas fa-columns">  vvvvvv </jbsTab>
                
      </jbsSideTabs>

    <div :class="[$route.name == 'MachinewithId' || $route.name == 'AllIssues'  && this.screenwidth < 979 ? 'mobile-issues' : 'router-container' ] ">
          <router-view />
        </div>

   </div>

 <div v-else>

<div :class="[$route.name == 'MachinewithId' || $route.name == 'AllIssues'  && this.screenwidth < 979 ? 'mobile-issues' : 'router-container' ] ">
      <router-view />
    </div>

 </div>
    <notificationslist />
  </div>
</template>

<script>
import appbar from "@/components/app-base/AppBar.vue";
import jbsSideTabs from "@/custom-components-test/jbsSideTabs.vue";
import jbsTab from "@/custom-components-test/jbsTab.vue"
import notificationslist from "@/components/utilities/Notifications/NotificationsList.vue";
import { mapState } from "vuex";


export default {
  components: {
    appbar,
    notificationslist,
    jbsSideTabs,
    jbsTab
  },
  name: "App",

  data: () => ({
    //   //
  }),
  mounted(){

    if(!this.$route.fullPath.includes("MachinebyId")){
    //this.connectToSignalr();
    }
  },
  methods: {
    connectToSignalr(){
   $.connection.hub.qs = {
        'BearerToken': this.user.access_token
  
    };
  $.connection.hub.url = "https://givemeachance.xyz/signalr";

  var chat = $.connection.messageHub;

// in comments second parameter "issue"

    $.connection.hub.logging = true;

     if ($.connection.hub && $.connection.hub.state === $.signalR.connectionState.disconnected) {

    $.connection.hub.start({ withCredentials: false}).done(function () {
        //debugger
        console.log('Now connected, connection ID=' + $.connection.hub.id);
    }).done(  () => {
             chat.server.connectedOnPage(null, "notmessagepage");
        }).fail(function (error) {
               debugger
               console.log('Invocation of NewContosoChatMessage failed. Error: ' + error);


           });
     } else {
        chat.server.connectedOnPage(null, "notmessagepage");
     }
  }
  },
  computed: {
    screenwidth: function() {
      return document.documentElement.clientWidth;
    },

     ...mapState({
      user: state => state.user.user,
      title: state => state.titlemessage.titletext
    }),  
  }
};
</script>
<style>
html {
  width: 100%;
}

body{
  margin: 0px;
  font-family: poppins, 'Roboto', sans-serif;
  background-color: #F7F8FC;
;
}

.router-container {
  margin-top: 60px;
  max-width: 100%;
  flex-grow: 1;
}

.mobile-issues {
  margin-top: 60px;
  max-width: 100%;
  margin-bottom: 0px;
}

@media (min-width: 250px) and (max-width: 979px) {
  .router-container {
    margin-bottom: 60px;
  }
}
</style>
